import { CheckmarkFilled16 } from '@carbon/icons-react';
import {
  SubscriptionTier,
  SubscriptionTierInTable,
  subscriptionHeaders,
  allFeatures,
  subscriptionData,
} from '@upright/common/activities/contact-forms/company-subscription/subscription-tiers';
import { NiceButton } from '@upright/ui/common/generic/components/buttons/nice-button';
import { getTextStyle } from '@upright/ui/common/generic/content/texts/bou-text/text-style';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import styled, { css } from 'styled-components';

interface Props {
  onTierClick: (tier: SubscriptionTierInTable) => void;
}

export const SubscriptionTableMobile = (props: Props) => {
  return (
    <>
      {subscriptionHeaders.map(category => {
        let features = allFeatures.filter(feature => feature in subscriptionData[category.name]);
        let prevCategory;
        if (category.name === SubscriptionTier.STANDARD) {
          features = features.filter(feature => !(feature in subscriptionData.Free));
          prevCategory = 'Free';
        } else if (category.name === SubscriptionTier.ADVANCED) {
          features = features.filter(feature => !(feature in subscriptionData.Standard));
          prevCategory = 'Standard';
        }
        return (
          <MobileContainer key={category.name}>
            <TopBar theme={category.theme} />
            <MobileContent
              onClick={() => {
                props.onTierClick(category.name);
              }}
            >
              <p className="subscription-table-header-text">{category.name}</p>
              {category.name === SubscriptionTier.STANDARD ? (
                <a
                  className="subscription-table-small-link"
                  onClick={() => {
                    props.onTierClick(category.name);
                  }}
                >
                  {category.description}
                </a>
              ) : (
                <p className="subscription-table-small-text">{category.description}</p>
              )}
              <NiceButton theme="dark" isOutlined={category.buttonOutlined}>
                {category.buttonText}
              </NiceButton>
              <FeaturesHeading>Includes</FeaturesHeading>
              {category.name !== 'Free' && (
                <p>
                  Everything in <strong>{prevCategory}</strong>, plus:
                </p>
              )}
              {features.map(item => (
                <MobileFeature key={item}>
                  <StyledIcon />
                  <p>{item}</p>
                </MobileFeature>
              ))}
            </MobileContent>
          </MobileContainer>
        );
      })}
    </>
  );
};

const MobileContainer = styled.div`
  margin-bottom: 2.5em;
  border-radius: 4px;
  background-color: ${BouColor.TOOL_BACKGROUND_WHITE};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 5%);
`;

const MobileContent = styled.div`
  padding: 1em 1em;
`;

const TopBar = styled.div<{ theme: string }>`
  height: 10px;
  border-radius: 4px 4px 0 0;
  ${props =>
    props.theme === 'purple' &&
    css`
      background-color: ${BouColor.IMPACT_NEGATIVE_PURPLE};
    `};
  ${props =>
    props.theme === 'turquoise' &&
    css`
      background-color: ${BouColor.IMPACT_POSITIVE_GREEN};
    `};
  ${props =>
    props.theme === 'yellow' &&
    css`
      background-color: ${BouColor.TOOL_BUTTON_BACKGROUND_YELLOW};
    `};
`;

const FeaturesHeading = styled.p`
  margin: 1em 0;
  ${getTextStyle({ size: 'small', isBold: true })}
`;

const MobileFeature = styled.div`
  display: flex;
  margin: 1em 0;
`;

const StyledIcon = styled(CheckmarkFilled16)`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 0.33em;
`;
